<div class="button-navigation flex flex-row space-between items-center">
  <button pButton type="button" class="atlas-btn atlas-btn-secondary tall" type="button"
    [routerLink]="['/profile', profileId]" [icon]="'pi pi-angle-left'"
    [label]="'profiles.back-to-profile' | translate | uppercase">
  </button>
  @if (profileContactsTabFullAccess) {
  <div class="flex content-end">
    <button pButton type="button" class="atlas-btn atlas-btn-primary tall" type="button" (click)="addContactClick()">
      {{ 'profiles.contact.add-new-contact' | translate | uppercase }}
    </button>
  </div>
  }
</div>
<div class="contacts-header flex row-collapse space-between items-start">
  <div>
    <span class="title-header">{{ 'profiles.contact.title' | translate | titlecase }}</span>
  </div>
  <div class="flex row gap-10px items-center">
    <wl-date-selector [(ngModel)]="startDate" (onDateChanged)="selectedDateChange()"></wl-date-selector>
    <span> {{ 'common.through' | translate }} </span>
    <wl-date-selector [(ngModel)]="endDate" (onDateChanged)="selectedDateChange()"></wl-date-selector>
  </div>
</div>

<div class="flex column gap-27px" *ngIf="contacts.Result.length">
  <div *ngFor="let profileContact of contacts.Result">
    <wl-profile-contact-card [profileContact]="profileContact" (deleteClicked)="onDeleteClicked($event)"
      (editClicked)="onEditClicked($event)"></wl-profile-contact-card>
  </div>
  <wl-paging-controls #pagingControls [pagedResult]="contacts" [hidden]="false"
    (pagingEvent)="onPagingEvent($event)"></wl-paging-controls>
</div>

<wl-profile-contact-edit [profileContact]="editableContact"
  (submitClicked)="onEditSubmitClicked($event)"></wl-profile-contact-edit>

<p-confirmDialog #cd key="deleteContactCD" header="{{ 'profiles.contact.delete-header' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">{{ 'common.cancel' |
      translate | uppercase }}</button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
